<template>
  <div class="events">
    <div class="inner-content">
      <Alert></Alert>

      <div class="events-list" v-if="elections.length > 0">
        <Card
          v-for="election in elections"
          :key="`election-${election.id}`"
          :title="election.title.rendered"
          :image="election.icon"
          :date="election.election_start ? [election.election_start, 'X'] : false"
          :link="{ name: 'election', params: {slug: decodeURIComponent(election.slug)} }"
          dark
        ></Card>
      </div>

      <h3 v-if="elections.length === 0 && !loading">Не бяха намерени предстоящи избори.</h3>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Card from '@/components/Card'
import Alert from '@/components/Utils/Alert.vue'

export default {
  name: 'ElectionsList',
  components: { Alert, Card },

  mounted () {
    this.fetchElections()
  },

  methods: {
    fetchElections () {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('getElections').catch(() => {
        this.$store.commit('showAlert', { type: 'error', message: 'Грешка при зареждането на изборите.' })
      }).finally(() => {
        this.$store.commit('setLoading', false)
      })
    }
  },

  computed: mapGetters(['elections', 'loading']),
}
</script>
